<template>
  <div class="blog-page">
    <pre-loader v-if="loading"/>
    <div v-else>
      <div class="blog-heading mb-2 p-2">BLOG</div>
      <div v-if="blog.length">
        <vue-infinite-scroll
          :is-loading="isLoadingMore"
          :is-end-reached="isEndReached"
          @load-more="loadMore"
        >
          <blog-article-short-view 
            v-for="article in blog"
            :key="article.urlPageName"
            :article="article"
            class="geoff-bg-section rounded-3 p-3 mb-2"/>
        </vue-infinite-scroll>
      </div>

      <div v-else class="geoff-bg-section rounded-3 p-3 mb-2">
        <div class="empty">
          Blog is empty.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PreLoader from "@/components/UI/PreLoader";
import VueInfiniteScroll from "@/components/UI/VueInfiniteScroll";
import BlogArticleShortView from "@/views/blog/BlogArticleShortView";
export default {
  name: "BlogView",
  components: {
    PreLoader,
    VueInfiniteScroll,
    BlogArticleShortView
  },
  data:()=>{
    return{
      loading: true,
      blog: [],
      // infinite scroll params
      isLoadingMore: false,
      isEndReached: false,
      itemsPerPage: null,
    }
  },
  computed: {
    currentPage() {
      return this?.blog?.length ? (Math.ceil(this.blog.length / this.itemsPerPage) + 1) : 1
    }
  },
  mounted() {
    this.loadMore()
  },
  methods:{
    loadMore(){
      if (!this.blogLoading) 
      {
        this.isLoadingMore = true
        this.API.getBlog(this.currentPage)
        .then(respData=>{
          // end is reached if there is no more items
          if (!respData?.data?.length) {
            this.isEndReached = true
          }
          else {
            this.blog.push(...respData.data)
            this.itemsPerPage = respData.pagination.limit
          }
          this.isLoadingMore = false
        })
        .finally(() => this.loading = false)

      }
    }
  }
}
</script>

<style scoped lang="scss">
  .blog-page { 
    .blog-heading {
      font-size: 1.5rem;
      font-weight: 700;
      color: var(--sbo-text-primary);
    }
    .empty {
      color: var(--sbo-text-note);
    }
  }
</style>